export default {"src":"/_next/static/media/X.481ff573.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};